import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DefinitionListCollection from './_DefinitionListCollection';

class DataTableCell extends React.Component {
  constructor() {
    super();
    this.state = { isGroupExpanded: true };
    this.toggleDropdownState = this.toggleDropdownState.bind(this);
  }

  // Function to toggle nested data when the table
  // is displayed as a list on smaller screens:
  toggleDropdownState() {
    this.setState(({ isGroupExpanded }) => ({ isGroupExpanded: !isGroupExpanded }));
  }

  render() {
    const {
      props: {
        cellData: {
          attributes,
          cellContent,
          columnHeadingContent,
          nestedCells,
          isMobileTermHidden
        }
      },
      state: {
        isGroupExpanded
      },
      toggleDropdownState
    } = this;

    const visibleMobileTerm = columnHeadingContent && !isMobileTermHidden;

    if (nestedCells !== undefined) {
      return (
        <td {...attributes}>
          <header className='table-cell-group-header'>
            {!visibleMobileTerm ? null : (
              <strong className='table-cell-label'>{columnHeadingContent}</strong>
            )}

            <button
              className='opener button-wrap'
              title='se detaljer' // TODO: add label or translation !!
              aria-expanded={isGroupExpanded}
              onClick={toggleDropdownState}
            >
              <FontAwesomeIcon icon={(isGroupExpanded) ? 'chevron-up' : 'chevron-down'} />
            </button>
          </header>

          {!isGroupExpanded ? null : <DefinitionListCollection listCollectionData={nestedCells} />}
        </td>
      );
    }

    return (
      <td {...attributes}>
        {!visibleMobileTerm ? null : (
          <strong className='table-cell-label'>{columnHeadingContent}</strong>
        )}

        <span>{cellContent}</span>
      </td>
    );
  }
}

export default DataTableCell;